<template>
  <div v-if="productIsLoaded" class="flex items-center py-3">
    <div class="flex-grow py-2 px-4 xs:hidden">
      <h3>{{ productTitle }}</h3>
      <div class="mt-1">{{ currentColor }}</div>
    </div>
    <div v-if="currentRoute !== 'basket'" :class="$style['slot']">
      <slot />
    </div>
  </div>
</template>
<script>
import { mapState } from 'pinia';
import { useRouterStore } from '@/store-pinia/router';

export default {
  name: 'ProductSummaryBar',
  computed: {
    productTitle() {
      return this.$store.getters['product/title'];
    },
    currentColor() {
      return this.$store.getters['product/currentColor'];
    },
    articleNumber() {
      return this.$store.getters['product/articleNumber'];
    },
    productIsLoaded() {
      return this.$store.state.product.isLoaded;
    },
    ...mapState(useRouterStore, ['currentRoute'])
  }
};
</script>
<style module>
.slot {
  @apply flex flex-row justify-around py-2 px-4;
}
@screen xs {
  .slot {
    @apply pin-b pin-l pin-r w-full fixed h-16 p-0 bg-sh-primary;
    z-index: 3000;
  }
}
</style>
